import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '../stores/auth'
import Layout from '../components/Layout.vue'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    component: Layout,
    children: [
      {
        path: '',
        name: 'Dashboard',
        component: () => import('../views/Dashboard.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'lands',
        name: 'Lands',
        component: () => import('../views/content/LandList.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'lands/create',
        name: 'LandCreate',
        component: () => import('../views/content/LandForm.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'lands/edit/:id',
        name: 'LandEdit',
        component: () => import('../views/content/LandForm.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'livestocks',
        name: 'Livestocks',
        component: () => import('../views/content/LivestockList.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'livestocks/create',
        name: 'LivestockCreate',
        component: () => import('../views/content/LivestockForm.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'livestocks/edit/:id',
        name: 'LivestockEdit',
        component: () => import('../views/content/LivestockForm.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'articles',
        name: 'Articles',
        component: () => import('../views/content/ArticleList.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'articles/create',
        name: 'ArticleCreate',
        component: () => import('../views/content/ArticleForm.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'articles/edit/:id',
        name: 'ArticleEdit',
        component: () => import('../views/content/ArticleForm.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'farms',
        name: 'Farms',
        component: () => import('../views/content/FarmList.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'farms/create',
        name: 'FarmCreate',
        component: () => import('../views/content/FarmForm.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'farms/edit/:id',
        name: 'FarmEdit',
        component: () => import('../views/content/FarmForm.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'farms/review',
        name: 'FarmProductReview',
        component: () => import('../views/content/FarmProductReview.vue'),
        meta: { requiresAuth: true, title: '商品审核' }
      },
      {
        path: 'users',
        name: 'Users',
        component: () => import('../views/content/UserList.vue'),
        meta: { requiresAuth: true, title: '用户管理' }
      },
      {
        path: 'users/create',
        name: 'UserCreate',
        component: () => import('../views/content/UserForm.vue'),
        meta: { requiresAuth: true, title: '新增用户' }
      },
      {
        path: 'users/edit/:id',
        name: 'UserEdit',
        component: () => import('../views/content/UserForm.vue'),
        meta: { requiresAuth: true, title: '编辑用户' }
      },
      {
        path: 'system/banners',
        name: 'Banners',
        component: () => import('../views/content/BannerList.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'system/banners/create',
        name: 'BannerCreate',
        component: () => import('../views/content/BannerForm.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'system/banners/edit/:id',
        name: 'BannerEdit',
        component: () => import('../views/content/BannerForm.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'orders',
        redirect: '/product-orders'
      },
      {
        path: 'adoptions',
        name: 'AdoptionManage',
        component: () => import('../views/adoption/AdoptionManage.vue'),
        meta: { requiresAuth: true, title: '认养订单' }
      },
      {
        path: 'product-orders',
        name: 'ProductOrders',
        component: () => import('../views/order/ProductOrderList.vue'),
        meta: { requiresAuth: true, title: '商品订单' }
      },
      {
        path: 'products',
        name: 'Products',
        component: () => import('../views/mall/ProductList.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'products/create',
        name: 'ProductCreate',
        component: () => import('../views/mall/ProductForm.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'products/edit/:id',
        name: 'ProductEdit',
        component: () => import('../views/mall/ProductForm.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'addresses',
        name: 'Addresses',
        component: () => import('../views/address/AddressList.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'addresses/create',
        name: 'AddressCreate',
        component: () => import('../views/address/AddressForm.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'addresses/edit/:id',
        name: 'AddressEdit',
        component: () => import('../views/address/AddressForm.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'settlement/applications',
        name: 'SettlementApplications',
        component: () => import('../views/Settlement/ApplicationList.vue'),
        meta: { requiresAuth: true, title: '入驻申请审核' }
      },
      {
        path: 'settlement/farm-changes',
        name: 'FarmChanges',
        component: () => import('../views/Settlement/FarmChangeList.vue'),
        meta: { requiresAuth: true, title: '农场设置变更审核' }
      },
      {
        path: 'settlement/adoption-review',
        name: 'AdoptionReview',
        component: () => import('../views/adoption/AdoptionReview.vue'),
        meta: { requiresAuth: true, title: '认养审核' }
      },
      {
        path: 'system/help-articles',
        name: 'HelpArticles',
        component: () => import('../views/system/HelpArticleList.vue'),
        meta: { requiresAuth: true, title: '帮助中心管理' }
      },
      {
        path: 'system/help-articles/create',
        name: 'HelpArticleCreate',
        component: () => import('../views/system/HelpArticleForm.vue'),
        meta: { requiresAuth: true, title: '新增帮助文章' }
      },
      {
        path: 'system/help-articles/edit/:id',
        name: 'HelpArticleEdit',
        component: () => import('../views/system/HelpArticleForm.vue'),
        meta: { requiresAuth: true, title: '编辑帮助文章' }
      },
      {
        path: 'system/home-intro',
        name: 'HomeIntro',
        component: () => import('../views/system/HomeIntroForm.vue'),
        meta: { requiresAuth: true, title: '简介管理' }
      },
      {
        path: 'system/about-us',
        name: 'AboutUs',
        component: () => import('../views/system/AboutUs.vue'),
        meta: { requiresAuth: true, title: '关于我们管理' }
      },
      {
        path: 'system/settings',
        name: 'SystemSettings',
        component: () => import('../views/system/SystemSettings.vue'),
        meta: { requiresAuth: true, title: '系统参数配置' }
      },
      {
        path: 'payments',
        name: 'Payments',
        component: () => import('../views/payment/PaymentList.vue'),
        meta: { requiresAuth: true, title: '支付记录' }
      },
      {
        path: 'payments/statistics',
        name: 'PaymentStatistics',
        component: () => import('../views/payment/PaymentStatistics.vue'),
        meta: { requiresAuth: true, title: '支付统计' }
      },
      {
        path: 'order-statistics',
        name: 'OrderStatistics',
        component: () => import('../views/order/OrderStatistics.vue'),
        meta: { requiresAuth: true, title: '订单统计' }
      },
      {
        path: 'farm-commissions',
        name: 'FarmCommissions',
        component: () => import('../views/finance/FarmCommission.vue'),
        meta: { requiresAuth: true, title: '农场提成' }
      },
      {
        path: 'farm-withdrawals',
        name: 'FarmWithdrawals',
        component: () => import('../views/finance/FarmWithdrawal.vue'),
        meta: { requiresAuth: true, title: '农场提现审核' }
      },
      {
        path: 'activities',
        name: 'Activities',
        component: () => import('../views/content/ActivityList.vue'),
        meta: { requiresAuth: true, title: '活动管理' }
      },
      {
        path: 'activities/create',
        name: 'ActivityCreate',
        component: () => import('../views/content/ActivityForm.vue'),
        meta: { requiresAuth: true, title: '新增活动' }
      },
      {
        path: 'activities/edit/:id',
        name: 'ActivityEdit',
        component: () => import('../views/content/ActivityForm.vue'),
        meta: { requiresAuth: true, title: '编辑活动' }
      },
      {
        path: 'operation-logs',
        name: 'OperationLogs',
        component: () => import('../views/log/OperationLogList.vue'),
        meta: { requiresAuth: true, title: '操作日志' }
      }
    ]
  },
  // 404 兜底路由
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('../views/NotFound.vue'),
    meta: { requiresAuth: false, title: '页面未找到' }
  }
]

const router = createRouter({
  // 管理后台部署在 /admin/ 下（官网占用根路径 /）
  history: createWebHistory('/admin/'),
  routes
})

// 路由守卫
const AUTH_LOADING_TIMEOUT = 5000
const AUTH_CHECK_INTERVAL = 100

router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore()

  // 检查用户是否有 token
  const hasToken = localStorage.getItem('access_token') || localStorage.getItem('token') || localStorage.getItem('refresh_token')

  // 如果认证检查正在进行，等待它完成
  if (authStore.loading) {
    const waitForLoading = () => {
      return new Promise((resolve, reject) => {
        const startTime = Date.now()
        let timeoutId = null

        const check = () => {
          if (!authStore.loading) {
            if (timeoutId) clearTimeout(timeoutId)
            resolve()
            return
          }

          if (Date.now() - startTime >= AUTH_LOADING_TIMEOUT) {
            if (timeoutId) clearTimeout(timeoutId)
            reject(new Error(`等待认证超时`))
            return
          }

          timeoutId = setTimeout(check, AUTH_CHECK_INTERVAL)
        }
        check()
      })
    }

    try {
      await waitForLoading()
    } catch (error) {
      console.warn('等待认证状态超时:', error.message)
    }
  }

  // 如果用户有 token 但未认证，尝试静默登录
  if (hasToken && !authStore.isAuthenticated) {
    try {
      await authStore.checkAuth()
    } catch (error) {
      console.error('静默登录失败:', error)
    }
  }

  // 检查认证状态并决定路由
  if (to.meta.requiresAuth) {
    // 需要认证的页面
    if (!authStore.isAuthenticated) {
      // 未认证，跳转到登录页，并记录来源页面
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
      return
    }
    // 已认证，允许访问
    next()
  } else if (to.path === '/login') {
    // 登录页面
    if (authStore.isAuthenticated) {
      // 已登录，跳转到首页或来源页面
      const redirect = to.query.redirect || '/'
      next(redirect)
      return
    }
    // 未登录，允许访问登录页
    next()
  } else {
    // 其他页面（如公开页面）
    next()
  }
})

export default router